import { reflect } from '@effector/reflect'

import { YahooButton as View } from '../view'
import * as model from './model'

export const YahooLoginButton = reflect({
    view: View,
    bind: {
        onClick: model.yahooLoginButtonClicked,
    },
})
